import { api } from '../api'

const state = {
  publicitygroups: [],
  publicitygroupsLoaded: false
}

const mutations = {
  'INIT_PUBLICITYGROUPS'(state, payload) {
    state.publicitygroups = payload
  },
  'TOGGLE_PUBLICITYGROUP_STATUS'(state) {
    state.publicitygroupsLoaded = !state.publicitygroupsLoaded
  },
  'ADD_PUBLICITYGROUP'(state, payload) {
    if (payload) {
      // push an entry to global state
      state.publicitygroups.push(
        {
          Groupname: payload.Groupname,
          idPublicitygroup: payload.idPublicitygroup,
          numberoffacilities: payload.numberoffacilities,
          numberofmonitors: payload.numberofmonitors
        }
      )
    }
  },
  'UPDATE_PUBLICITYGROUP'(state, payload) {
    if (payload) {
      // update publicitygroup global state
      let publicitygroup = state.publicitygroups.find(pg => pg.idPublicitygroup === payload.publicitygroupid)
      publicitygroup.numberoffacilities = payload.numberoffacilities
      publicitygroup.numberofmonitors = payload.numberofmonitors
    }
  }
}

const getters = {
  getPublicitygroupStatus: state => {
    return state.publicitygroupsLoaded
  },
  getPublicitygroupOverview: state => {
    return state.publicitygroups.map(publicitygroup => {
      return {
        groupname: publicitygroup.Groupname,
        numberOfFacilities: publicitygroup.numberoffacilities,
        numberOfMonitors: publicitygroup.numberofmonitors
      }
    })
  },
  // exclude group "Alle" since novel items are automatically assigned to it (on db level)
  getPublicitygroupNames: state => {
    return state.publicitygroups.map(publicitygroup => publicitygroup.Groupname).filter(publicitygroupname => publicitygroupname !== "Alle")
  },
  // only group with at least 1 facility assigned
  getPublicitygroupNamesInclAll: state => {
    return state.publicitygroups.filter(group => group.numberoffacilities > 0).map(publicitygroup => publicitygroup.Groupname)
  },
  getPlannerPublicitygroupObjects: (state) => (payload) => {
    return state.publicitygroups.filter(publicitygroup => {
      return payload.includes(publicitygroup.Groupname)
    }).map(publicitygroup => {
      return {
        publicitygroupid: publicitygroup.idPublicitygroup,
        publicitygroupname: publicitygroup.Groupname
      }
    })
  },
  getPlannerPublicitygroupObject: (state) => (payload) => {
    let pg = state.publicitygroups.find(publicitygroup => payload === publicitygroup.Groupname)
    return {
      publicitygroupid: pg.idPublicitygroup,
      publicitygroupname: pg.Groupname
    }
  },
  getPublicitygroupIdByName: state => payload => {
    return state.publicitygroups.filter(group => group.Groupname === payload)[0].idPublicitygroup
  }
}

const actions = {
  // TODO error handling!!!!!!!
  loadPublicitygroups: ({ commit, state, rootState }) => {
    api.queryAPIServerGet(process.env.VUE_APP_ROOT_API + "/publicitycustomer/publicitygroups/get", { pid: rootState.auth.pid, username: rootState.auth.Username }, (response) => {
      let data = response.data.data
      // replace null with 0 for visual representation
      data.forEach(el => {
        if (el.numberoffacilities === null) el.numberoffacilities = 0
      })
      commit("INIT_PUBLICITYGROUPS", data)
      if (!state.publicitygroupsLoaded) {
        commit('TOGGLE_PUBLICITYGROUP_STATUS')
      }
    })
  },
  submitPublicitygroup: ({ commit, rootState }, payload) => {
    payload.pid = rootState.auth.pid;
    payload.username = rootState.auth.Username;

    return new Promise((resolve) => {
      api.queryAPIServerPost(process.env.VUE_APP_ROOT_API + "/publicitycustomer/publicitygroups/submit", payload, (response) => {
        let res = response.data;

        if (res.error) {
          console.error('An error occured. Please try again later.');
          resolve(1)
          return
        }

        if (res.data) {
          commit('ADD_PUBLICITYGROUP', {
            idPublicitygroup: res.data.publicitygroupid,
            Groupname: res.data.publicitygroupname,
            numberoffacilities: res.data.numberoffacilities,
            numberofmonitors: res.data.numberofmonitors
          })
          resolve(0)
        }
      })
    })
  },
  updatePublicitygroup: ({ commit, rootState }, payload) => {
    payload.pid = rootState.auth.pid
    payload.username = rootState.auth.Username

    return new Promise(resolve => {
      api.queryAPIServerPost(process.env.VUE_APP_ROOT_API + "/publicitycustomer/publicitygroups/update", payload, response => {
        let res = response.data;

        if (res.error) {
          console.log('An error occured. Please try again later.');
          resolve(1)
          return
        }

        if (res.data) {
          commit('UPDATE_PUBLICITYGROUP', res.data)
          resolve(0)
        }
      })
    })
  },
}

export default {
  state,
  mutations,
  getters,
  actions
}
